import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, getToken } from '../../api';

export default function Done() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getToken()) { navigate('/login'); return; }
    api.get('/profile').then(p => setName(p.name?.split(' ')[0] || '')).catch(() => {});
  }, [navigate]);

  // Fade in then auto-advance after 3s
  useEffect(() => {
    const fadeTimer = setTimeout(() => setVisible(true), 100);
    const navTimer  = setTimeout(() => navigate('/onboarding/read', { replace: true }), 3000);
    return () => { clearTimeout(fadeTimer); clearTimeout(navTimer); };
  }, [navigate]);

  return (
    <div style={{
      height: '100vh',
      background: '#000',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 40px',
      textAlign: 'center',
      opacity: visible ? 1 : 0,
      transition: 'opacity 0.8s ease',
    }}>
      {name && (
        <div style={{
          fontFamily: 'var(--font-display)',
          fontSize: 42,
          fontWeight: 300,
          color: 'var(--gold)',
          marginBottom: 32,
          letterSpacing: '-0.01em',
        }}>
          {name}.
        </div>
      )}
      <div style={{
        fontSize: 18,
        fontWeight: 300,
        color: 'var(--text)',
        lineHeight: 1.7,
        marginBottom: 12,
      }}>
        I found you three people this week.
      </div>
      <div style={{
        fontSize: 18,
        fontWeight: 300,
        color: 'var(--muted)',
      }}>
        Here's why.
      </div>
    </div>
  );
}
